window.sq = window.sq || {};

window.sq.onData = function (data) {
  data.results.forEach((x) => {
    if (
      window.sqCustomerId === "" &&
      (x.collectionHandles.indexOf("login") > -1 || 
       x.collectionHandles.indexOf("login-1") > -1)
    ) {
      x.hidePrice = true;
    } else {
      x.hidePrice = false;
    }
  });

  if(window.innerWidth<767){
      let abc = document.querySelectorAll(".sparq-layout");
      if(abc.length>1) abc[1].remove();
  }
  return data;
};

// window.sq.onComplete = function(el){
// 	let html = `
// 	<div class='sq-title-2'> Log in om sommige prijzen te kunnen zien.<br> klik hier om in te 
//   		<a class="sq-login" href="/account/login"> loggen</a> of vraag uw 
//   		<a class="sq-account" href="/account/register">account</a> aan.
// 	</div>
// `;
//   let containerElement = el.querySelector(".sq-filters-wrapper");
//   let sortElement = el.querySelector(".sq-title-2");
  
// if (sortElement || !containerElement) return;
//   containerElement.insertAdjacentHTML("afterend",html);

// }

window.sq.config.translations.nl.dropdownViewAllButtonText = "Bekijk alles";
 window.onload = function() {
    setTimeout(() => {
      console.log(customerIsLogged);
        if (!customerIsLogged) {
            document.querySelectorAll(".lpShowPrice").forEach(e => {
                e.classList.add("sq-custom-show");
            });
        }
    }, 1500);
 }

window.sq.fetchPrice = function (item, isDropdown = false) {
  if (!item || !item.handle) {
    return true;
  }

  fetch(
    location.origin +
      `/products/${item.handle.toLowerCase()}.json`
  )
    .then((response) => response.json())
    .then((obj) => {
      if (
        !obj.product ||
        !obj.product.variants ||
        !obj.product.variants.length
      ) {
        return;
      }

      const variant = obj.product.variants[0];
      const productPrice = variant.price;
      const compareAtPrice = variant.compare_at_price;

     function formatPrice(price) {
  if (
    price === null ||
    price === undefined ||
    price === ""
  ) {
    return "";
  }

  const priceNumber = Number(price);

  if (Number.isNaN(priceNumber)) {
    return String(price);
  }

  // Whole-number prices
  if (Number.isInteger(priceNumber)) {
    return `€ ${priceNumber},-`;
  }

  // Keep decimal prices with a dot
  return `€ ${priceNumber.toFixed(2)}`;
}

      function updatePrices() {
        let productElements;

        if (isDropdown) {
          productElements = document.querySelectorAll(
            `.sq-dropdown-body [product-handle="${item.handle}"]`
          );
        } else {
          productElements = document.querySelectorAll(
            `[product-handle="${item.handle}"]`
          );
        }

        productElements.forEach((productElement) => {
          const normalPriceElement =
            productElement.querySelector(".sq-price");

          const finalPriceElement =
            productElement.querySelector(".sq-mrp-final-price");

          const comparePriceElement =
            productElement.querySelector(
              ".sparq-compare-price .sq-mrp-price"
            );

          /*
           * Update the product price wherever it is currently rendered.
           * Do not depend on JSON compare_at_price to choose the element.
           */
          if (normalPriceElement && productPrice) {
            normalPriceElement.textContent =
              formatPrice(productPrice);
          }

          if (finalPriceElement && productPrice) {
            finalPriceElement.textContent =
              formatPrice(productPrice);
          }

          if (comparePriceElement && compareAtPrice) {
            comparePriceElement.textContent =
              formatPrice(compareAtPrice);
          }
        });
      }

      // Allow Vue to finish rendering
      setTimeout(updatePrices, 0);
      setTimeout(updatePrices, 200);
      setTimeout(updatePrices, 500);
    })
    .catch((error) => {
      console.error(
        `Unable to fetch price for ${item.handle}:`,
        error
      );
    });

  return true;
};